import { useContext, useEffect, useRef, useState } from "react";
import { Offcanvas } from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { AlignLeft, LogOut, User } from "lucide-react";
import { images } from "../assets/images";
import { ReactComponent as LeaderboardIcon } from "../assets/images/Leaderboard.svg";
import { ReactComponent as RewardIcon } from "../assets/images/Rewards.svg";
import { ReactComponent as LearningIcon } from "../assets/images/LearningCenter.svg";
import { ReactComponent as ChatsIcon } from "../assets/images/Chats.svg";
import { ReactComponent as PointHistoryIcon } from "../assets/images/PointHistory.svg";
import { ReactComponent as AboutUsIcon } from "../assets/images/aboutUs.svg";
import { ReactComponent as PrivacyPolicyIcon } from "../assets/images/PrivacyPolicy.svg";
import AppModal from "./AppModal";
import storage from "../assets/js/Global";
import { GlobalContext } from "../context/GlobalContext";

const SidebarContent = ({
  setShow,
  navigate,
  location,
  homeRoute,
  isProfileActive,
  setShowLogoutModal,
  isMobile,
}) => {
  const isHomeActive = [
    "/home",
    "/details",
    "/end-job",
    "/end-job-details",
  ].includes(location.pathname);

  const isRewardsActive = ["/rewards", "/reward-redeem"].includes(
    location.pathname,
  );

  const { profileData, preview, unreadMessages } = useContext(GlobalContext);
  const cachedUser = storage.get("user");
  const firstName = profileData?.firstName || cachedUser?.first_name || "";
  const lastName = profileData?.lastName || cachedUser?.last_name || "";
  const email = profileData?.email || cachedUser?.email || "";
  const profileImg = preview || cachedUser?.profile_img;

  const isLearningActive = ["/learning-list", "/read-learning"].includes(
    location.pathname,
  );

  const isChatsActive = ["/chat-list", "/chats", "/new-chat-list"].includes(
    location.pathname,
  );
  return (
    <>
      <div className="sideBarUserDetails shadow-bottom bg-primary d-flex align-items-center justify-content-center">
        {isMobile ? (
          <div
            className="d-flex align-items-center gap-2 w-100"
            onClick={() => {
              navigate("/profile");
              setShow(false);
            }}
          >
            <div className="menu-profile-image">
              <img
                src={profileImg || images.userAvatar}
                alt="user-img"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = images.userAvatar;
                }}
              />
            </div>

            <div>
              <h6 className="user-name-text mb-0">
                {firstName} {lastName}
              </h6>
              <p className="user-email mb-0">{email}</p>
            </div>
          </div>
        ) : (
          <div className="text-center w-100">
            <img
              src={images.appLogo}
              alt="logo"
              style={{ height: "48px", objectFit: "contain" }}
            />
          </div>
        )}
      </div>
      <div className="sidebar-list mt-1">
        <div>
          <Link
            to={homeRoute}
            className={`nav-link option-list ${isHomeActive ? "active-option" : ""}`}
            onClick={() => setShow(false)}
          >
            <div
              className={`sidebar-icon ${isHomeActive ? "active-option-icon" : ""}`}
            >
              <i className="fa-solid fa-house"></i>
            </div>
            Home
          </Link>
          {/* <Link
            to={"/schedule"}
            className={`nav-link option-list ${
              location.pathname === "/schedule" ? "active-option" : ""
            }`}
            onClick={() => setShow(false)}
          >
            <div
              className={`sidebar-icon ${
                location.pathname === "/schedule" ? "active-option-icon" : ""
              }`}
            >
              <i className="fa-solid fa-calendar-day"></i>
            </div>
            Schedule
          </Link> */}
          <Link
            to={"/clock"}
            className={`nav-link option-list mt-2 ${
              location.pathname === "/clock" ? "active-option" : ""
            }`}
            onClick={() => setShow(false)}
          >
            <div
              className={`sidebar-icon ${
                location.pathname === "/clock" ? "active-option-icon" : ""
              }`}
            >
              <i className="fa-solid fa-clock"></i>
            </div>
            Work Log
          </Link>
          <Link
            to={"/leaderboard"}
            className={`nav-link option-list ${
              location.pathname === "/leaderboard" ? "active-option" : ""
            }`}
            onClick={() => setShow(false)}
          >
            <div
              className={`sidebar-icon ${
                location.pathname === "/leaderboard" ? "active-option-icon" : ""
              }`}
            >
              <LeaderboardIcon
                className={`sidebar-icon-svg ${
                  location.pathname === "/leaderboard"
                    ? "active-option-icon"
                    : ""
                }`}
              />
            </div>
            Leaderboard
          </Link>
          <Link
            to={"/rewards"}
            className={`nav-link option-list ${isRewardsActive ? "active-option" : ""}`}
            onClick={() => setShow(false)}
          >
            <div
              className={`sidebar-icon ${
                isRewardsActive ? "active-option-icon" : ""
              }`}
            >
              <RewardIcon
                className={`sidebar-icon-svg ${
                  isRewardsActive ? "active-option-icon" : ""
                }`}
              />
            </div>
            Rewards
          </Link>
          <Link
            to={"/learning-list"}
            className={`nav-link option-list ${isLearningActive ? "active-option" : ""}`}
            onClick={() => setShow(false)}
          >
            <div
              className={`sidebar-icon ${
                isLearningActive ? "active-option-icon" : ""
              }`}
            >
              <LearningIcon
                className={`sidebar-icon-svg ${
                  isLearningActive ? "active-option-icon" : ""
                }`}
              />
            </div>
            Learning Center
          </Link>
          <Link
            to={"/chat-list"}
            className={`nav-link option-list ${isChatsActive ? "active-option" : ""}`}
            onClick={() => setShow(false)}
          >
            <div
              className={`sidebar-icon ${
                isChatsActive ? "active-option-icon" : ""
              }`}
            >
              <ChatsIcon
                className={`sidebar-icon-svg ${
                  isChatsActive ? "active-option-icon" : ""
                }`}
              />
            </div>
            Chats
            {unreadMessages > 0 && (
              <span className="chat-unread-badge">
                {unreadMessages > 99 ? "99+" : unreadMessages}
              </span>
            )}
          </Link>

          {isMobile && (
            <Link
              to={"/profile"}
              className={`nav-link option-list ${
                isProfileActive ? "active-option" : ""
              }`}
              onClick={() => setShow(false)}
            >
              <div
                className={`sidebar-icon ${
                  location.pathname === "/profile" ? "active-option-icon" : ""
                }`}
              >
                <i className="fa-solid fa-user-pen"></i>
              </div>
              Profile
            </Link>
          )}
          <Link
            to={"/points-history"}
            className={`nav-link option-list ${
              location.pathname === "/points-history" ? "active-option" : ""
            }`}
            onClick={() => setShow(false)}
          >
            <div
              className={`sidebar-icon ${
                location.pathname === "/points-history"
                  ? "active-option-icon"
                  : ""
              }`}
            >
              <PointHistoryIcon
                className={`sidebar-icon-svg ${
                  location.pathname === "/points-history"
                    ? "active-option-icon"
                    : ""
                }`}
              />
            </div>
            Point History
          </Link>
          <Link
            to={"/about-us"}
            className={`nav-link option-list ${
              location.pathname === "/about-us" ? "active-option" : ""
            }`}
            onClick={() => setShow(false)}
          >
            <div
              className={`sidebar-icon ${
                location.pathname === "/about-us" ? "active-option-icon" : ""
              }`}
            >
              <AboutUsIcon
                className={`sidebar-icon-svg small-width ${
                  location.pathname === "/about-us" ? "active-option-icon" : ""
                }`}
              />
            </div>
            About Us
          </Link>
          <Link
            to={"/privacy-policy"}
            className={`nav-link option-list ${
              location.pathname === "/privacy-policy" ? "active-option" : ""
            }`}
            onClick={() => setShow(false)}
          >
            <div
              className={`sidebar-icon ${
                location.pathname === "/privacy-policy"
                  ? "active-option-icon"
                  : ""
              }`}
            >
              <PrivacyPolicyIcon
                className={`sidebar-icon-svg ${
                  location.pathname === "/privacy-policy"
                    ? "active-option-icon"
                    : ""
                }`}
              />
            </div>
            Privacy Policy
          </Link>
          <Link
            to={"/terms-condition"}
            className={`nav-link option-list ${
              location.pathname === "/terms-condition" ? "active-option" : ""
            }`}
            onClick={() => setShow(false)}
          >
            <div
              className={`sidebar-icon ${
                location.pathname === "/terms-condition"
                  ? "active-option-icon"
                  : ""
              }`}
            >
              <i className="fa-solid fa-shield-halved"></i>
            </div>
            Terms & Conditions
          </Link>
        </div>
        {isMobile && (
          <div
            className="logout-link fade-in cursor-pointer"
            onClick={() => setShowLogoutModal(true)}
          >
            <div className="me-2">
              <LogOut size={16} strokeWidth="3" className="text-white" />
            </div>
            Log out
          </div>
        )}
        <div className="text-center py-2" style={{ opacity: 0.45 }}>
          <p className="mb-0 text-white fs-11">v 0.1.0</p>
        </div>
      </div>
    </>
  );
};

const Header = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { heartBeat, profileData, preview, clearProfile, doLogout } =
    useContext(GlobalContext);
  const cachedUser = storage.get("user");
  const firstName = profileData?.firstName || cachedUser?.first_name || "";
  const lastName = profileData?.lastName || cachedUser?.last_name || "";
  const email = profileData?.email || cachedUser?.email || "";
  const profileImg = preview || cachedUser?.profile_img;
  const currentPath = location.pathname;
  const detailsName = location.state?.name;
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 991);

  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const [show, setShow] = useState(false);
  const [showProfileDropdown, setShowProfileDropdown] = useState(false);
  const profileDropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        profileDropdownRef.current &&
        !profileDropdownRef.current.contains(e.target)
      ) {
        setShowProfileDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const menuIconRoutes = [
    "/home",
    "/privacy-policy",
    "/terms-condition",
    "/profile",
    "/about-us",
    "/leaderboard",
    "/rewards",
    "/learning-list",
    "/chat-list",
    "/points-history",
    "/privacy-policy",
    "/terms-condition",
    "/clock",
    "/schedule",
  ];
  const profilePaths = [
    "/profile",
    "/profile-update",
    "/change-password",
    "/deleteAcc-one",
    "/language-selection",
  ];

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 991);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const isDashboard = menuIconRoutes.includes(currentPath);
  const isProfileActive = profilePaths.includes(location.pathname);

  const routeTitles = {
    "/home": (
      <div className="d-flex flex-column mt-1">
        <p className={`mb-0 fs-18 ${isMobile ? "text-white" : "text-primary"}`}>
          Welcome,
        </p>
        <p
          className={`mb-0 fs-18 ${isMobile ? "text-secondary" : "text-secondary"}`}
        >
          {(firstName?.charAt(0).toUpperCase() || "") +
            (firstName?.slice(1) || "")}{" "}
          {lastName}
        </p>
      </div>
    ),

    "/privacy-policy": "Privacy Policy",
    "/terms-condition": "Terms & Conditions",
    "/profile": "Profile",
    "/about-us": "About Us",
    "/leaderboard": "Leaderboard",
    "/details": detailsName || "Details",
    "/end-job": detailsName || "End Job",
    "/end-job-details": detailsName || "End Job",
    "/rewards": "Rewards",
    "/reward-redeem": "Redeem Point",
    "/points-history":
      location.state?.tab === "redeemHistory"
        ? "Redeem History"
        : "Point History",
    "/learning-list": "Learning Center",
    "/read-learning": "Course Details",
    "/chat-list": "Chats",
    "/new-chat-list": "New Chat",
    "/clock": "Work Log",
  };

  let pageTitle = routeTitles[location.pathname] || "App";

  const handleBack = () => {
    const currentPath = location.pathname;

    if (
      currentPath === "/deleteAcc-one" ||
      currentPath === "/change-password"
    ) {
      navigate("/profile");
    } else if (currentPath === "/profile" || currentPath === "/end-job") {
      navigate("/home");
    } else {
      navigate(-1);
    }
  };

  const homeRoute = "/home";
  const hideHeader = ["/chat-list", "/new-chat-list"];
  const hideBackIconRoutes = ["/end-job"];

  return (
    <>
      {location.pathname !== "/chats" &&
        (isMobile ||
          !hideHeader.some((path) => location.pathname.includes(path))) && (
          <nav className="navbar fixed-top header-part">
            <div className="nav-link navbar-brand text-black d-flex gap-1 align-items-center w-100 p-0 justify-content-between me-0">
              <div
                className="d-flex align-items-center gap-2 flex-grow-1 overflow-hidden"
                style={{ minWidth: 0 }}
              >
                {isDashboard ? (
                  <span onClick={() => setShow(true)} className="mobile-toggle">
                    <AlignLeft
                      className={`cursor-pointer ${isMobile ? "text-white" : "text-primary"}`}
                    />
                  </span>
                ) : hideBackIconRoutes.includes(currentPath) ? null : (
                  <Link
                    onClick={(e) => {
                      e.preventDefault();
                      handleBack();
                    }}
                    className="nav-link navigation-icon me-2"
                  >
                    <i
                      className={`fa-solid fa-angle-left ${isMobile ? "text-white" : "text-primary"}`}
                    ></i>
                  </Link>
                )}
                <h5 className="header-text mb-0 text-start ms-2 flex-grow-1">
                  {pageTitle}
                </h5>
              </div>
              {isMobile ? (
                <div
                  className="d-flex gap-1 align-items-center cursor-pointer"
                  onClick={() => {
                    navigate("/profile");
                    setShow(false);
                  }}
                >
                  <div className="menu-profile-image">
                    <img
                      src={profileImg || images.userAvatar}
                      alt="user-img"
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = images.userAvatar;
                      }}
                    />
                  </div>
                </div>
              ) : (
                <div className="position-relative" ref={profileDropdownRef}>
                  <div
                    className="cursor-pointer"
                    onClick={() => setShowProfileDropdown((p) => !p)}
                  >
                    <div className="menu-profile-image">
                      <img
                        src={profileImg || images.userAvatar}
                        alt="user-img"
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = images.userAvatar;
                        }}
                      />
                    </div>
                  </div>

                  {showProfileDropdown && (
                    <div
                      className="position-absolute bg-white overflow-hidden"
                      style={{
                        right: 0,
                        top: "calc(100% + 12px)",
                        minWidth: "240px",
                        zIndex: 9999,
                        boxShadow: "0 8px 32px rgba(0,0,0,0.14)",
                        border: "1px solid rgba(0,0,0,0.07)",
                        borderRadius: "16px",
                      }}
                    >
                      {/* User info header */}
                      <div className="px-4 pt-3 pb-2 border-bottom d-flex align-items-center gap-3">
                        <div
                          className="rounded-circle overflow-hidden flex-shrink-0"
                          style={{
                            width: 44,
                            height: 44,
                            border: "2px solid #0d6efd40",
                          }}
                        >
                          <img
                            src={profileImg || images.userAvatar}
                            alt="user"
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "cover",
                            }}
                            onError={(e) => {
                              e.target.onerror = null;
                              e.target.src = images.userAvatar;
                            }}
                          />
                        </div>
                        <div className="overflow-hidden">
                          <p className="mb-0 fw-bold text-dark fs-14 text-truncate">
                            {(firstName?.charAt(0).toUpperCase() || "") +
                              (firstName?.slice(1) || "")}{" "}
                            {lastName}
                          </p>
                          <p className="mb-0 text-muted fs-13 text-truncate">
                            {email}
                          </p>
                        </div>
                      </div>

                      {/* Menu items */}
                      <div className="py-1">
                        <div
                          className="px-4 py-2 d-flex align-items-center gap-3 cursor-pointer fs-14 text-dark"
                          style={{ transition: "background 0.15s" }}
                          onMouseEnter={(e) =>
                            (e.currentTarget.style.background = "#f4f6fb")
                          }
                          onMouseLeave={(e) =>
                            (e.currentTarget.style.background = "")
                          }
                          onClick={() => {
                            setShowProfileDropdown(false);
                            navigate("/profile");
                          }}
                        >
                          <span
                            className="d-flex align-items-center justify-content-center rounded-circle"
                            style={{
                              width: 30,
                              height: 30,
                              background: "#0d6efd15",
                            }}
                          >
                            <User size={14} className="text-primary" />
                          </span>
                          My Profile
                        </div>

                        <div
                          className="mx-3"
                          style={{ height: 1, background: "#f0f0f0" }}
                        />

                        <div
                          className="px-4 pt-2 pb-3 d-flex align-items-center gap-3 cursor-pointer fs-14 text-danger"
                          style={{ transition: "background 0.15s" }}
                          onMouseEnter={(e) =>
                            (e.currentTarget.style.background = "#fff0f0")
                          }
                          onMouseLeave={(e) =>
                            (e.currentTarget.style.background = "")
                          }
                          onClick={() => {
                            setShowProfileDropdown(false);
                            setShowLogoutModal(true);
                          }}
                        >
                          <span
                            className="d-flex align-items-center justify-content-center rounded-circle"
                            style={{
                              width: 30,
                              height: 30,
                              background: "#ff000015",
                            }}
                          >
                            <LogOut size={14} />
                          </span>
                          Log out
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              )}
            </div>
          </nav>
        )}

      <div className="sidebar-desktop sidebar-background">
        <SidebarContent
          setShow={setShow}
          navigate={navigate}
          location={location}
          homeRoute={homeRoute}
          isProfileActive={isProfileActive}
          setShowLogoutModal={setShowLogoutModal}
          isMobile={isMobile}
        />
      </div>

      {/* Mobile Offcanvas */}
      <Offcanvas
        show={show}
        onHide={() => setShow(false)}
        placement="start"
        className="p-0 text-black shadow-lg sidebar-background"
        style={{ width: "240px" }}
      >
        <Offcanvas.Body className="p-0">
          <SidebarContent
            setShow={setShow}
            navigate={navigate}
            location={location}
            homeRoute={homeRoute}
            isProfileActive={isProfileActive}
            setShowLogoutModal={setShowLogoutModal}
            isMobile={isMobile}
          />
        </Offcanvas.Body>
      </Offcanvas>
      <AppModal
        type="logout"
        show={showLogoutModal}
        onClose={() => setShowLogoutModal(false)}
        onConfirm={async () => {
          setShowLogoutModal(false);
          await doLogout();
          navigate("/login");
        }}
      />
    </>
  );
};

export default Header;
